export const environment = {
  production: true,
  apiEndpoint: 'https://api-demo.worryandpeace.com/',
  membrsEndpoint: 'https://staging.memb.rs/api/v1/',
  membrsLoginPage: 'https://marketplace-demo.staging.memb.rs/login',
  envName: 'demo',
  apiKey: 'ZSunY2a4hX-T2vQ2Y7rpd-bzy7aZpFL5',
  authMethod: 'jwt',
  stripe: 'pk_test_MkDKfK3P2xdDvJu4jSP0VTVI',
  customerMarketplace: 'https://customer.marketplace.worryandpeace.com',
  cookieDomain: '.marketplace.worryandpeace.com',
  cookieSecure: true
};